import { Table, Spin, Divider, Typography } from "antd";
import { fmt } from "./tenantPaymentHelpers";

interface Props {
  payments: any[];
  paymentsLoading: boolean;
}

export const TenantPaymentHistory: React.FC<Props> = ({
  payments,
  paymentsLoading,
}) => {
  const { Text } = Typography;

  const paymentColumns = [
    {
      title: "Due Date",
      dataIndex: "due_date",
      key: "due_date",
      render: (v: string) => v || "-",
    },
    {
      title: "Period",
      key: "period",
      render: (_: any, r: any) =>
        r.billing_period_start && r.billing_period_end
          ? `${r.billing_period_start} → ${r.billing_period_end}`
          : "-",
    },
    {
      title: "Package",
      dataIndex: "package_name",
      key: "package_name",
      render: (v: string) => v || <Text type="secondary">—</Text>,
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (v: number) => fmt(v),
    },
    {
      title: "Paid At",
      dataIndex: "paid_at",
      key: "paid_at",
      render: (v: string) => (v ? new Date(v).toLocaleString() : "-"),
    },
    {
      title: "Method",
      dataIndex: "payment_method",
      key: "payment_method",
      render: (v: string) => v || "-",
    },
    {
      title: "Reference",
      dataIndex: "reference",
      key: "reference",
      render: (v: string) => v || "-",
    },
    {
      title: "Note",
      dataIndex: "note",
      key: "note",
      render: (v: string) => v || "-",
    },
  ];

  return (
    <>
      <Divider orientation="left" plain>
        Payment History
      </Divider>
      {paymentsLoading ? (
        <Spin />
      ) : (
        <Table
          size="small"
          rowKey="id"
          pagination={{ pageSize: 5 }}
          columns={paymentColumns}
          dataSource={payments || []}
          locale={{ emptyText: "No payments recorded yet." }}
        />
      )}
    </>
  );
};
